import React, { useEffect, useState, useContext } from "react";
import Select from "react-select";
import { apiService } from "../../service/ApiService";
import { Form } from "react-bootstrap";
import StoreContext from "contexts/StoreContext";

import { useTranslation } from "react-i18next";

const ExtrasCategorySelect = ({ title, defaultValue = null, handler, id = null }) => {
  const {
    t,
  } = useTranslation();

  title = title === undefined ? t("forms.placeholders.selectExtraCategory") : title;
  const [extraCategories, setExtraCategories] = useState([]);
  const [selectedExtraCategory, setSelectedExtraCategory] = useState(null);
  const { storeId, setStoreId } = useContext(StoreContext);

  const handleChange = (e) => {
    setSelectedExtraCategory(e);
    if (e) handler(e.value);
    else handler(null);
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  const getExtraCategories = async () => {
    try {
      const response = await apiService.get(`api/v1/extra-categories/store/${storeId}`);
      const activeExtraCategories = response.filter((el) => !el.deleted);
      const availableExtraCategories = activeExtraCategories.map((el) => {
        return {
          value: el.id,
          label: el.name,
        };
      });
      setExtraCategories(availableExtraCategories);
      if (id) {
        availableExtraCategories.map((o) => {
          if (o.value == id) {
            o.isDisabled = true;
            return o;
          }
        });
      }
      setNewValue(null);
    } catch (error) {
      console.error(error);
    }
  };

  const setNewValue = () => {
    const selectedExtraCategory = extraCategories.find((el) => el.value === defaultValue);
    if (selectedExtraCategory) setSelectedExtraCategory(selectedExtraCategory);
  };

  useEffect(() => {
    if (!storeId) return;
    getExtraCategories();
  }, [storeId]);

  useEffect(() => {
    setNewValue();
  }, [defaultValue]);

  return (
    <>
      <Form.Group>
        <label>{title}</label>
        <Select
          styles={customStyles}
          isClearable={true}
          className="primary"
          name="extraCategorySelect"
          onChange={handleChange}
          value={selectedExtraCategory}
          options={extraCategories}
          noOptionsMessage={() => t("messages.noExtraCategoriesAreAvailable")}
          placeholder={`${t("common.actions.select")} ${title}`}
        />
      </Form.Group>
    </>
  );
};

export default ExtrasCategorySelect;
